import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MultiReturnMessagePopupComponent } from './components/multi-returns-message-popup.component';
import { MultiReturnsMessageNavigationService } from './multi-returns-message-navigation.service';
import { MultiReturnsMessageTrackingService } from './multi-returns-message-tracking.service';
import MultiReturnsMessageService from './multi-returns-message.service';

@NgModule({
    declarations: [MultiReturnMessagePopupComponent],
    providers: [MultiReturnsMessageService, MultiReturnsMessageTrackingService, MultiReturnsMessageNavigationService],
    imports: [CommonModule],
    exports: [MultiReturnMessagePopupComponent],
})
export class BetslipDigitalMultiReturnsMessageModule {}
